// import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Provider } from "react-redux";
import store from "./redux/store";

import ScrollToTop from "../src/components/ScrollToTop";
import { Toaster } from "react-hot-toast";
import "./App.css";

import {
  Login,
  Otp,
  Registration,
  Dashboard,
  UserInformaion,
  KYCInformation,
  Gifting,
  SellRedeem,
  GoldCoin,
  CoinPriceBreakup,
  MFCollections,
  Esign,
  EsignComplete,
  RedeemPriceBreakup,
  MyHoldings,
  FundDeatils,
  PaymentScreen,
  PaymentSuccess,
  MyProfile,
  TransactionScreen,
  MFTransaction,
  GoldSilverTransaction,
  SellBreakup,
  SellSuccess,
  TransactionDeatils,
  PaymentComplete,
  MFPaymentDone,
  MFMandateStatus,
  Nominee,
  Support,
  AddNomineeScreen,
  BankDetails,
  EsignDone,
  GoalHomeScreen,
  GoalDetailScreen,
  ActiveSIP,
  NFOFundDetails,
  AssistedPaymentCompete,
  AssistedEsign
} from "./pages";
// ... other imports

// const Login = lazy(() => import("../src/pages/authentication/Login"));
// const Otp = lazy(() => import("../src/pages/authentication/Otp"));
// const Registration = lazy(
//   () => import("../src/pages/authentication/Registration")
// );
const RootRedirect = () => {
  const location = useLocation();
  return <Navigate to={{ pathname: "/login", search: location.search }} replace />;
};

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "'Poppins', sans-serif",
    },
  },
});

const App = () => {
  const toasterOptions = {
    style: {
      fontWeight: 500,
      fontFamily: "'Poppins', sans-serif",
    },
};

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/*" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/otp" element={<Otp />} />
            <Route path="/register" element={<Registration />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/userdetails" element={<UserInformaion />} />
            <Route path="/gifting" element={<Gifting />} />
            <Route path="/kycinformation" element={<KYCInformation />} />
            <Route path="/sellredeem" element={<SellRedeem />} />
            <Route path="/goldcoin" element={<GoldCoin />} />
            <Route path="/coinpriceBreakup" element={<CoinPriceBreakup />} />
            <Route
              path="/redeemPriceBreakup"
              element={<RedeemPriceBreakup />}
            />
            <Route path="/mutualfundcollections" element={<MFCollections />} />
            <Route path="/esign" element={<Esign />} />
            <Route path="/esigncomplete" element={<EsignComplete />} />
            <Route path="/myholdings" element={<MyHoldings />} />
            <Route path="/funddetails" element={<FundDeatils />} />
            <Route path="/goldPayment" element={<PaymentScreen />} />
            <Route path="/paymentSucess" element={<PaymentSuccess />} />
            <Route path="/priceBreakup" element={<SellBreakup />} />
            <Route path="/myProfile" element={<MyProfile />} />
            <Route path="/transaction" element={<TransactionScreen />} />
            <Route path="/mftransaction" element={<MFTransaction />} />
            <Route
              path="/goldsilvertransaction"
              element={<GoldSilverTransaction />}
            />
            <Route path="/success" element={<SellSuccess />} />
            <Route path="/transactiondetail" element={<TransactionDeatils />} />
            <Route path="/paymentcomplete" element={<PaymentComplete />} />
            <Route path="/mfpaymentdone" element={<MFPaymentDone />} />
            <Route path="/mandateStatus" element={<MFMandateStatus />} />
            <Route path="/nominee" element={<Nominee />} />
            <Route path="/support" element={<Support />} />
            <Route path="/bankDetails" element={<BankDetails />} />
            <Route path="/addNominee" element={<AddNomineeScreen />} />
            <Route path="/esigndone" element={<EsignDone />} />
            <Route path="/assistedPaymentCompete" element={<AssistedPaymentCompete />} />
            <Route path="/assistedEsign" element={<AssistedEsign />} />

            
            {/* Goals */}
            <Route path="/goalDashboard" element={<GoalHomeScreen />} />
            <Route path="/goalDetails" element={<GoalDetailScreen />} />

            {/* SIP */}
            <Route path="/activesip" element={<ActiveSIP />} />
            <Route path="/nfofunddetails" element={<NFOFundDetails />} />

          </Routes>
        </Router>
      </ThemeProvider>
      <Toaster toastOptions={toasterOptions} />
    </Provider>
  );
};

export default App;
